import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { QuestionnaireProcessStep } from 'src/app/common/enums';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { WorkerService } from 'src/app/data/worker.service';
import { WorkerProfile } from 'src/app/models/WorkerProfile';
import { GetBankAccountNumberConfigurationResponse } from 'src/app/contracts/responses/get-bank-account-number-configuration-response';

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss'],
  standalone: false
})
export class AdditionalInfoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private workerService = inject(WorkerService);

  profile$!: Observable<WorkerProfile>;
  bankAccountConfiguration$!: Observable<GetBankAccountNumberConfigurationResponse>;
  profile: WorkerProfile;
  questionnaireProcessStep = QuestionnaireProcessStep;

  constructor() { }

  get authServerUserId(): string {
    return this.profile?.AuthServerUserId;
  }

  get isSelfProfile(): boolean {
    return this.authServerUserId === this.authService.authServerUserId;
  }

  get emergencyContactOnProfile(): boolean {
    return (this.profile?.EmergencyContactPhone !== null ||
      this.profile?.EmergencyContactAddress !== null ||
      this.profile?.EmergencyContactFirstName !== null ||
      this.profile?.EmergencyContactLastName !== null);
  }

  ngOnInit(): void {
    this.profile$ = this.route.parent.data.pipe(
      map(data => data['workerProfile'] as WorkerProfile),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.bankAccountConfiguration$ = this.profile$.pipe(
      switchMap(profile => this.workerService.getBankAccountNumberConfiguration(profile.WorkerId)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.profile$.subscribe(profile => (this.profile = profile));
  }
}
